module.exports = __webpack_public_path__ + "static/img/weather43.25491902.png";